<template>
  <div id="labelAutocomplete">
    <ul class="list-group" style="position: absolute; width: 100%; z-index: 999">
      <li v-for="(label, index) in filteredLabels" v-bind:key="index" class="list-group-item">
        <a href="javascript:;" @click="$emit('selected', label)">{{label}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'label-autocomplete',
  data: function () {
    return {
      labels: []
    }
  },
  props: {
    query: {
      type: String,
      default: ''
    }
  },
  computed: {
    filteredLabels: function () {
      if (this.query === null || this.query.length < 3) return []

      var results = []
      var context = this
      this.labels.forEach(function (label) {
        var query = context.query.toUpperCase()
        var target = label.toUpperCase()

        if (target.indexOf(query) != -1) results.push(label)
      })

      return results
    }
  },
  beforeMount: function() {
    var url = process.env.API_BASE_URL + '/itembank/labels'
    var authToken = JSON.parse(localStorage.getItem('token')).value
    var options = {
      headers: {
        'Authorization': authToken
      }
    }

    var context = this
    axios.get(url, options).then(function (response) {
      if (response.status === 200) {
        response.data.forEach(function (d) {
          context.labels.push(d)
        })
      }
    })
  }
}
</script>




// WEBPACK FOOTER //
// LabelAutocomplete.vue?c3f380d2